<template>
  <div>
    <div>
      <div class="d-flex align-items-center mb-3">
        <h1 class="m-0 me-3">Transactions</h1>
        <transaction-add-button class="ms-auto" @transaction-added="handleTransactionAdded" />
      </div>

      <static-alert v-if="errors" :message="errors" @on-hide="errors=''" />

      <local-transactions ref="transactionListRef" />

    </div>
  </div>
</template>

<script setup>

import { ref } from 'vue'

import LocalTransactions from "@/app/components/transactions/TransactionList.vue";
import StaticAlert from "@/app/components/Utils/StaticAlert.vue";
import TransactionAddButton from "@/app/components/transactions/TransactionAddButton.vue";

const transactionListRef = ref(null)

function handleTransactionAdded(result) {
  console.log('Transaction added:', result)
  // Trigger refresh of the transaction list
  if (transactionListRef.value) {
    transactionListRef.value.loadTransactions()
  }
}


</script>
